import UserModel from '@/models/UserModel.js'
import { PROMEET_HANDLE } from '@/constants/links.js'

export default class UsersRepository {
  rootStore = null

  #users = new Map()

  constructor(rootStore) {
    this.rootStore = rootStore
  }

  get auth() {
    return this.rootStore.authStore
  }

  reset = () => {
    this.#users.forEach(x => x.reset())
    this.#users.clear()
  }

  get api() {
    return this.rootStore.apiStore
  }

  createOrUpdate = userData => {
    const address = userData.address ?? userData.owner

    if (!address) {
      console.error('[Users] Cannot create or update without an address')

      return null
    }

    if (address === this.auth.user?.address) {
      this.auth.user.update(userData)

      return this.auth.user
    }

    let user = this.#users.get(address)

    if (user) {
      user.update(userData)

      return user
    }

    user = new UserModel(this.rootStore, userData)
    this.#users.set(address, user)

    return user
  }

  get = address => {
    if (!address) {
      console.error('[Users] Cannot get without address')

      return null
    }

    if (address === this.auth.user?.address) return this.auth.user

    return this.#users.get(address)
  }

  getFromServer = async x => {
    if (!x) {
      console.error('[Users] Cannot get from server without a handle, nickname or address')

      return null
    }

    const response = await this.api.getUserByHandleNicknameOrAddress(x)

    return response ? this.createOrUpdate(response.data) : null
  }

  getPromeetUser = async () =>
    (await this.get(PROMEET_HANDLE)) ?? (await this.getFromServer(PROMEET_HANDLE))
}
